import { render, staticRenderFns } from "./party_attribute_edit.vue?vue&type=template&id=4dfa1a16&scoped=true&"
import script from "./party_attribute_edit.vue?vue&type=script&lang=js&"
export * from "./party_attribute_edit.vue?vue&type=script&lang=js&"
import style0 from "./party_attribute_edit.vue?vue&type=style&index=0&id=4dfa1a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfa1a16",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardText,VCardTitle,VCheckbox,VCol,VCombobox,VContainer,VDivider,VForm,VIcon,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585234252/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dfa1a16')) {
      api.createRecord('4dfa1a16', component.options)
    } else {
      api.reload('4dfa1a16', component.options)
    }
    module.hot.accept("./party_attribute_edit.vue?vue&type=template&id=4dfa1a16&scoped=true&", function () {
      api.rerender('4dfa1a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/party_attribute_edit.vue"
export default component.exports